module.exports = __webpack_public_path__ + "img/zabix.d73ef7f2.webp";